import { render, staticRenderFns } from "./CadastroCliente.vue?vue&type=template&id=2527c128"
import script from "./CadastroCliente.vue?vue&type=script&lang=js"
export * from "./CadastroCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports